import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const NavLinksContainer = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 2rem',
    height: '100%',
    '& a': {
        color: 'var(--nav-text-color)',
        cursor: 'pointer',
        display: 'center',
        alignItems: 'flex-end',
        padding: '0 1rem',
        textDecoration: 'none',
        fontFamily: 'var(--nav-font-family)',
        height: '100%',
        '& .MuiTypography-root': {
            fontSize: '1.25rem',
            color: 'var(--nav-text-color)',
            fontFamily: 'var(--nav-font-family)',
        },
        '&.selected': {
            '& .MuiTypography-root': {
                fontWeight: 'bold',
            },
            '& .MuiSvgIcon-root': {
                fontSize: '1.65rem',
            },
        },
        '& .MuiSvgIcon-root': {
            margin: '0 .1rem',
            padding: '.1rem',
        },
    },
    '& button': {
        height: '100%',
    },
}));
